import { Box, Button, Divider } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

import { AuthRole } from '@libs/types';
import { ChatButton } from '@carcareers/components';
import { routes } from '@carcareers/utils';
import { useAuth } from '@carcareers/hooks';

export const AppbarJobseekerAuth = () => {
  const { session } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const showButtons = location.pathname?.substring(1) !== routes?.JOBSEEKERS;

  if (session?.user?.role !== AuthRole.JOBSEEKER) {
    return null;
  }

  return (
    <Box
      sx={{
        justifyContent: 'right',
        flexGrow: 1,
        display: showButtons ? { xs: 'none', md: 'flex' } : 'none',
        mr: 3,
        gap: 2,
        alignItems: 'center',
      }}
    >
      <Button onClick={() => navigate(`/${routes.JOBSEEKERS}`)} sx={{ color: 'text.primary', fontWeight: 700 }}>
        Job Search
      </Button>
      <Button onClick={() => navigate(`/${routes.JOBSEEKER_HOME}/${routes.JOBSEEKER_APPLICATIONS}`)} sx={{ color: 'text.primary', fontWeight: 700 }}>
        Applied
      </Button>
      <Button onClick={() => navigate(`/${routes.JOBSEEKER_HOME}/${routes.JOBSEEKER_SAVED}`)} sx={{ color: 'text.primary', fontWeight: 700 }}>
        Saved
      </Button>
      <Divider orientation="vertical" flexItem sx={{ height: '20px', alignSelf: 'center' }} />
      <ChatButton />
      <Divider orientation="vertical" flexItem sx={{ height: '20px', alignSelf: 'center' }} />
    </Box>
  );
};

export default AppbarJobseekerAuth;
